export const formTabulations = [
    {
        code: "GENERAL",
        label: "Informations générales",
        anchor: "general-tab",
        active: false,
        hidden: false,
        component: "General",
    },
    {
        code: "PRIVATE_DESC",
        label: null,
        anchor: null,
        active: false,
        hidden: true,
        component: "PrivateDescriptifs",
    },
    {
        code: "LOCALISATION",
        label: "Localisation",
        anchor: "localisation-tab",
        active: false,
        hidden: false,
        component: "Localisation",
    },
    {
        code: "COMMUNICATION",
        label: "Moyens de contact",
        anchor: "contact-tab",
        active: false,
        hidden: false,
        component: "Contacts",
    },
    {
        code: "PLATFORM",
        label: "Site web et plateformes",
        anchor: "platform-tab",
        active: false,
        hidden: false,
        component: "Platform",
    },
    {
        code: "MEDIA",
        label: "Vos multimédias",
        anchor: "media-tab",
        active: false,
        hidden: false,
        component: "Medias",
    },
    {
        code: "ACTIVITE",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "COMMERCE_ET_SERVICE",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "HEBERGEMENT_COLLECTIF",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "EQUIPEMENT",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "FETE_ET_MANIFESTATION",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "HEBERGEMENT_LOCATIF",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "HOTELLERIE",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "HOTELLERIE_PLEIN_AIR",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "PATRIMOINE_CULTUREL",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "PATRIMOINE_NATUREL",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "PRODUCTEUR",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "RESTAURATION",
        label: "Informations spécifiques",
        anchor: "specific-tab",
        active: false,
        hidden: false,
        component: "Specific",
    },
    {
        code: "OPENING_HOURS",
        label: "Périodes et horaires d'ouvertures",
        anchor: "opening-period-tab",
        active: false,
        hidden: false,
        component: "OpeningHours",
    },
    {
        code: "TARIF",
        label: "Tarifs",
        anchor: "price-period-tab",
        active: false,
        hidden: false,
        component: "PricePeriods",
    },
    {
        code: "CAPACITES",
        label: "Capacités",
        anchor: "capacity-tab",
        active: false,
        hidden: false,
        component: "Capacities",
    },
    {
        code: "ACCES_HANDICAPES",
        label: "Accès aux personnes en situation de handicap",
        anchor: "handicapped-tab",
        active: false,
        hidden: false,
        component: "Handicapped",
    },
    {
        code: "ROOM_RENTING",
        label: "Location de salles",
        anchor: "room-renting-tab",
        active: false,
        hidden: false,
        component: "RoomRenting",
    },
    {
        code: "COVID",
        label: "Dispositions sanitaires",
        anchor: "covid-tab",
        active: false,
        hidden: false,
        component: "Covid",
    },
    {
        code: "CONTACTS",
        label: "Contacts",
        anchor: "contacts-tab",
        active: false,
        hidden: false,
        component: "ApidaeContacts",
    },
    {
        code: "FORM_VALIDATION",
        label: "Validation du formulaire",
        anchor: "validation-tab",
        active: false,
        hidden: false,
        component: "Extra",
    },
]

export const fieldsMapping = [
    {
        code: "ACCEPTED_ANIMALS",
        path: "boolean_elements",
        property: "value",
        filter: {
            path: "attribute.code",
            value: "ACCEPTED_ANIMALS",
        },
    },
    {
        code: "DISABLED_RECEPTION",
        path: "boolean_elements",
        property: "value",
        filter: {
            path: "attribute.code",
            value: "DISABLED_RECEPTION",
        },
    },
    {
        code: "DATE_CLASSEMENT_HLO",
        path: "date_fields",
        property: "value",
        filter: {
            path: "code",
            value: "DATE_CLASSEMENT_HLO",
        },
    },
    {
        code: "NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE",
        path: "numeric_fields",
        property: "value",
        filter: {
            path: "attribute.code",
            value: "NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE",
        },
    },
    {
        code: "DESC_PORTRAIT",
        path: "contents",
        property: "description_portrait",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_2023_INNOVATION",
        path: "contents",
        property: "description_2023_innovation",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_2024_INNOVATION",
        path: "contents",
        property: "description_2024_innovation",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_2025_INNOVATION",
        path: "contents",
        property: "description_2025_innovation",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_2026_INNOVATION",
        path: "contents",
        property: "description_2026_innovation",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_2027_INNOVATION",
        path: "contents",
        property: "description_2027_innovation",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_UNAVOIDABLE",
        path: "contents",
        property: "description_unavoidable",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "OFFER_PROMOTIONS",
        path: "contents",
        property: "offer_promotions",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_PARTY_MENU",
        path: "contents",
        property: "description_party_menu",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_ALERTE",
        path: "contents",
        property: "alerte",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_CRUISERS_SERV",
        path: "contents",
        property: "cruisers_service",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_GIFT_CERTIFICATE",
        path: "contents",
        property: "gift_certificate",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_ADVICE_SUGG",
        path: "contents",
        property: "advices_suggestions",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_CHILD_SERVICE",
        path: "contents",
        property: "child_service",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_CYCLIST_SERVICE",
        path: "contents",
        property: "cyclist_service",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_RIDERS_SERVICE",
        path: "contents",
        property: "riders_service",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_HIKERS_SERVICE",
        path: "contents",
        property: "hikers_service",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_TAKEAWAY",
        path: "contents",
        property: "takeaway",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_WINES_LABEL",
        path: "contents",
        property: "wines_label",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_GOOD_REASONS",
        path: "contents",
        property: "description_good_reasons",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_TOURISME_DURABLE",
        path: "contents",
        property: "description_sustainable_tourism",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_COVID19",
        path: "contents",
        property: "description_theme_covid",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_HAND_AUDITIF",
        path: "contents",
        property: "desc_handi_auditif",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_HAND_MOTEUR",
        path: "contents",
        property: "desc_handi_moteur",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_HAND_VISUEL",
        path: "contents",
        property: "desc_handi_visuel",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_HAND_MENTAL",
        path: "contents",
        property: "desc_handi_mental",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "OFFER_NAME",
        path: "name",
        property: null,
        filter: null,
    },
    {
        code: "OFFER_NAME_EN",
        path: "name_en",
        form_label: 'Nom de l\'offre',
        small_icon: "/images/flags/en.png",
        property: null,
        filter: null,
    },
    {
        code: "ADDRESS",
        path: "localisation",
        property: "address",
        filter: null,
        suggestion: "AddressSuggestion",
    },
    {
        code: "COMPLEMENT_ADDRESS",
        path: "localisation",
        property: "complement",
        filter: null,
    },
    {
        code: "ADDRESS3",
        path: "localisation",
        property: "address3",
        filter: null,
    },
    {
        code: "COMPLEMENT_LOCALISATION",
        path: "localisation",
        property: "access",
        filter: null,
    },
    {
        code: "POSTAL_CODE",
        path: "localisation",
        property: "postal_code",
        filter: null,
    },
    {
        code: "CITY",
        path: "localisation",
        property: "commune",
        filter: null,
    },
    {
        code: "PROVINCE",
        path: "localisation",
        property: "province",
        filter: null,
    },
    {
        code: "IMAGE",
        path: "medias",
        property: "copyright",
        filter: null,
        suggestion: "MediaSuggestion",
    },
    {
        code: "PHONE",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "PHONE",
        },
        suggestion: "CommunicationSuggestion",
        addHr: true,
    },
    {
        code: "FREE_PHONE",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "FREE_PHONE",
        },
        addHr: true,
    },
    {
        code: "EMAIL",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "EMAIL",
        },
        suggestion: "CommunicationSuggestion",
        addHr: false,
    },
    {
        code: "FAX",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "FAX",
        },
        addHr: true,
    },
    {
        code: "WEBSITE",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "WEBSITE",
        },
        addHr: true,
        formats: [
            /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,9}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i,
        ],
        formatError: "Le lien de votre site web n'est pas au bon format",
    },
    {
        code: "WEBSITE_EN",
        path: "communications",
        property: "value",
        small_icon: "/images/flags/en.png",
        filter: {
            path: "type.name",
            value: "WEBSITE_EN",
        },
        addHr: true,
        formats: [
            /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,9}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i,
        ],
        formatError: "Le lien de votre site web n'est pas au bon format",
    },
    {
        code: "GOOGLE",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "GOOGLE",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-GOOGLE.jpg",
        placeholder: "Lien de votre page Google MyBusiness",
        suggestion: "PlatformSuggestion",
        formats: [
            /^(https?:\/\/)?((w{3}\.)?)google\.(com|fr)\/maps\/place\/\b/i,
            /^(https?:\/\/)?((w{3}\.)?)maps.google\.(com|fr)\/\?cid=[0-9]/,
            /^(https?:\/\/)?((w{3}\.)?)maps.APP.goo\.gl\/\b/i,
            /^https?:\/\/(www\.)?(google\.[a-z]{2,3}|g\.co)\/[a-zA-Z0-9\/\-_]+(\?[a-zA-Z0-9&%=._\-]*)?$/,
        ],
        formatError: "Le lien de votre page Google MyBusiness n'est pas au bon format",
    },
    {
        code: "TRIPADVISOR",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "TRIPADVISOR",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-TRIPADVISOR.jpg",
        placeholder: "Lien de votre page Tripadvisor",
        suggestion: "PlatformSuggestion",
        formats: [
            /^(https?:\/\/)?((w{3}\.)?([a-z]{2}\.)?)?tripadvisor\.(com|fr|ca)\/.*$/i,
        ],
        formatError: "Le lien de votre page Tripadvisor n'est pas au bon format",
    },
    {
        code: "YELP",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "YELP",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-YELP.jpg",
        placeholder: "Lien de votre page Yelp",
        suggestion: "PlatformSuggestion",
        formats: [
            /^(https?:\/\/)?(www\.)?yelp\.com\/biz\/[\p{L}0-9-]+$/iu,
            /^(https?:\/\/)?(www\.)?yelp\.com\/biz\/[a-zA-Z0-9\/\-_]+(\?[a-zA-Z0-9&%=._\-]*)?$/,
        ],
        formatError: "Le lien de votre page Yelp n'est pas au bon format",
    },
    {
        code: "FACEBOOK",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "FACEBOOK",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-FACEBOOK.jpg",
        placeholder: "Lien de votre page Facebook",
        suggestion: "PlatformSuggestion",
        formats: [
            /^(https?:\/\/)?((w{3}\.)?)((fr-fr\.)?)facebook.(com|fr)\/.*/i,
        ],
        formatError: "Le lien de votre page Facebook n'est pas au bon format",
    },
    {
        code: "YOUTUBE",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "YOUTUBE",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-YOUTUBE.jpg",
        placeholder: "Lien de votre page Youtube",
        suggestion: "PlatformSuggestion",
        formats: [
            /^(https?:\/\/)?(www\.)?youtube\.com\/(channel|user|watch)(\?v=[\w-]+|\/[\w-]+)$/i,
            /^(https?:\/\/)?(www\.)?youtu\.be\/[\w-]+$/i,
            /^https?:\/\/(www\.)?(youtube\.com\/(user|channel)\/[a-zA-Z0-9_-]+|youtu\.be\/[a-zA-Z0-9_-]+|www\.youtube\.com\/@([a-zA-Z0-9_-]+))$/,
        ],
        formatError: "Le lien de votre page Youtube n'est pas au bon format",
    },
    {
        code: "INSTAGRAM",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "INSTAGRAM",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-INSTAGRAM.jpg",
        placeholder: "Lien de votre page Instagram",
        suggestion: "PlatformSuggestion",
        formats: [
            /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am|instagr.com)\/(\w+)/img,
        ],
        formatError: "Le lien de votre page Instagram n'est pas au bon format",
    },
    {
        code: "TWITTER",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "TWITTER",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-TWITTER.jpg",
        placeholder: "Lien de votre page X",
        suggestion: "PlatformSuggestion",
        formats: [
            /^(https?:\/\/)?((w{3}\.)?)(twitter|x)\.com\/(#!\/)?[a-z0-9_]+\/?$/i,
        ],
        formatError: "Le lien de votre page X n'est pas au bon format",
    },
    {
        code: "LINKEDIN",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "LINKEDIN",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-LINKEDIN.jpg",
        placeholder: "Lien de votre page Linkedin",
        suggestion: "PlatformSuggestion",
        formats: [
            /^(https?:\/\/)?(www\.)?linkedin\.(com|fr)/i,
        ],
        formatError: "Le lien de votre page Linkedin n'est pas au bon format",
    },
    {
        code: "TIKTOK",
        path: "communications",
        property: "value",
        filter: {
            path: "type.name",
            value: "TIKTOK",
        },
        addHr: false,
        hideTitle: true,
        icon: "/images/logo-TIKTOK.jpg",
        placeholder: "Lien de votre page TikTok",
        suggestion: "PlatformSuggestion",
        formats: [
            /^(https?:\/\/)?(www\.)?tiktok\.com\/@/i,
        ],
        formatError: "Le lien de votre page TikTok n'est pas au bon format",
    },
    {
        code: "OPENING_HOURS",
        path: "opening_periods",
        property: null,
        filter: null,
        suggestion: "OpeningPeriodSuggestion",
    },
    {
        code: "DESC_COURT_FR",
        path: "contents",
        property: "description",
        maxlength: 255,
        icon: "/images/flags/fr.png",
        modules: [
            {
                name: "AI",
                type: "SHORT",
                typeWord: "courte",
            },
        ],
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_COURT_EN",
        path: "contents",
        property: "description",
        icon: "/images/flags/en.png",
        filter: {
            path: "language.code",
            value: "en",
        },
    },
    {
        code: "DESC_COURT_DE",
        path: "contents",
        property: "description",
        icon: "/images/flags/de.png",
        filter: {
            path: "language.code",
            value: "de",
        },
    },
    {
        code: "DESC_COURT_IT",
        path: "contents",
        property: "description",
        icon: "/images/flags/it.png",
        filter: {
            path: "language.code",
            value: "it",
        },
    },
    {
        code: "DESC_COURT_NL",
        path: "contents",
        property: "description",
        icon: "/images/flags/nl.png",
        filter: {
            path: "language.code",
            value: "nl",
        },
    },
    {
        code: "DESC_COURT_ES",
        path: "contents",
        property: "description",
        icon: "/images/flags/es.png",
        filter: {
            path: "language.code",
            value: "es",
        },
    },
    {
        code: "DESC_COURT_RU",
        path: "contents",
        property: "description",
        icon: "/images/flags/ru.png",
        filter: {
            path: "language.code",
            value: "ru",
        },
    },
    {
        code: "DESC_COURT_PT",
        path: "contents",
        property: "description",
        icon: "/images/flags/pt.png",
        filter: {
            path: "language.code",
            value: "pt",
        },
    },
    {
        code: "DESC_COURT_ZH",
        path: "contents",
        property: "description",
        icon: "/images/flags/zh.png",
        filter: {
            path: "language.code",
            value: "zh",
        },
    },
    {
        code: "DESC_COURT_JA",
        path: "contents",
        property: "description",
        icon: "/images/flags/ja.png",
        filter: {
            path: "language.code",
            value: "ja",
        },
    },
    {
        code: "DESC_LONG_FR",
        path: "contents",
        property: "description_long",
        icon: "/images/flags/fr.png",
        modules: [
            {
                name: "AI",
                type: "LONG",
                typeWord: "longue",
            },
        ],
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_LONG_EN",
        path: "contents",
        property: "description_long",
        icon: "/images/flags/en.png",
        filter: {
            path: "language.code",
            value: "en",
        },
    },
    {
        code: "DESC_LONG_DE",
        path: "contents",
        property: "description_long",
        icon: "/images/flags/de.png",
        filter: {
            path: "language.code",
            value: "de",
        },
    },
    {
        code: "DESC_LONG_IT",
        path: "contents",
        property: "description_long",
        icon: "/images/flags/it.png",
        filter: {
            path: "language.code",
            value: "it",
        },
    },
    {
        code: "DESC_LONG_NL",
        path: "contents",
        property: "description_long",
        icon: "/images/flags/nl.png",
        filter: {
            path: "language.code",
            value: "nl",
        },
    },
    {
        code: "DESC_LONG_ES",
        path: "contents",
        property: "description",
        icon: "/images/flags/es.png",
        filter: {
            path: "language.code",
            value: "es",
        },
    },
    {
        code: "DESC_LONG_RU",
        path: "contents",
        property: "description",
        icon: "/images/flags/ru.png",
        filter: {
            path: "language.code",
            value: "ru",
        },
    },
    {
        code: "DESC_LONG_PT",
        path: "contents",
        property: "description",
        icon: "/images/flags/pt.png",
        filter: {
            path: "language.code",
            value: "pt",
        },
    },
    {
        code: "DESC_LONG_ZH",
        path: "contents",
        property: "description",
        icon: "/images/flags/zh.png",
        filter: {
            path: "language.code",
            value: "zh",
        },
    },
    {
        code: "DESC_LONG_JA",
        path: "contents",
        property: "description",
        icon: "/images/flags/ja.png",
        filter: {
            path: "language.code",
            value: "ja",
        },
    },
    {
        code: "CHIEF",
        path: "contents",
        property: "chef",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "AGREMENT_NUMBER",
        path: "contents",
        property: "agrement_number",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "DESC_ANIMALS_WELCOME",
        path: "contents",
        property: "description_animals_welcome",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "CITQ_NUMBER",
        path: "contents",
        property: "citq_number",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "QUEBEC_CAPACITY_TOTAL_FR",
        path: "contents",
        property: "quebec_total_capacity",
        type: "textarea",
        icon: "/images/flags/fr.png",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "QUEBEC_CAPACITY_TOTAL_EN",
        path: "contents",
        property: "quebec_total_capacity",
        type: "textarea",
        icon: "/images/flags/en.png",
        filter: {
            path: "language.code",
            value: "en",
        },
    },
    {
        code: "COMPLEMENT_ACCUEIL",
        path: "contents",
        property: "complement_accueil",
        placeholder: "Insérez les conseils et recommandations liées à l'utilisation de l'équipement de loisirs.",
        filter: {
            path: "language.code",
            value: "fr",
        },
    },
    {
        code: "COMPLEMENT_TARRIFAIRE",
        path: "pricing_complement",
        property: null,
        filter: null,
    },
    {
        code: "BOOKING_LINK",
        path: "booking_links",
        property: "value",
        filter: {
            path: "type.name",
            value: "WEBSITE",
        },
        formats: [
            /^(?:(?:https?|ftp):\/\/)?(?:[\w-]+\.)+[a-z]{2,}(?:\/\S*)?$/i,
        ],
        formatError: "Le lien de réservation n'est pas au bon format",
    },
    {
        code: "BOOKING_LINK_EN",
        path: "booking_links",
        property: "value",
        small_icon: "/images/flags/en.png",
        filter: {
            path: "type.name",
            value: "WEBSITE_EN",
        },
        formats: [
            /^(?:(?:https?|ftp):\/\/)?(?:[\w-]+\.)+[a-z]{2,}(?:\/\S*)?$/i,
        ],
        formatError: "Le lien de réservation n'est pas au bon format",
    },
    {
        code: "CONTACT_LAST_NAME",
        path: "contacts",
        property: "last_name",
        filter: null,
    },
    {
        code: "CONTACT_FIRST_NAME",
        path: "contacts",
        property: "first_name",
        filter: null,
    },
    {
        code: "CONTACT_PHONE",
        path: "contacts",
        property: "phone",
        filter: null,
    },
    {
        code: "CONTACT_EMAIL",
        path: "contacts",
        property: "email",
        filter: null,
    },
    {
        code: "CONTACT_TITLE",
        path: "contacts",
        property: "title",
        filter: null,
    },
    {
        code: "ContactFonction",
        path: "contacts",
        property: "profession.label",
        filter: {
            path: "profession",
            value: null,
        },
    },
    {
        code: "CONTACT_ADDRESS",
        path: "contacts",
        property: "address",
        filter: null,
    },
    {
        code: "CONTACT_POSTAL_CODE",
        path: "contacts",
        property: "postal_code",
        filter: null,
    },
    {
        code: "CONTACT_PHONE2",
        path: "contacts",
        property: "phone_2",
        filter: null,
    },
    {
        code: "CONTACT_CITY",
        path: "contacts",
        property: "commune",
        filter: null,
    },
    {
        code: "CONTACT_PROVINCE",
        path: "contacts",
        property: "province",
        filter: null,
    },
    {
        code: "MIN_AGE",
        path: "numeric_fields",
        property: "value",
        filter: {
            path: "attribute.code",
            value: "MIN_AGE",
        },
    },
    {
        code: "MAX_AGE",
        path: "numeric_fields",
        property: "value",
        filter: {
            path: "attribute.code",
            value: "MAX_AGE",
        },
    },
    {
        code: "MAX_GROUP_SIZE",
        path: "numeric_fields",
        property: "value",
        filter: {
            path: "attribute.code",
            value: "MAX_GROUP_SIZE",
        },
    },
    {
        code: "MIN_GROUP_SIZE",
        path: "numeric_fields",
        property: "value",
        filter: {
            path: "attribute.code",
            value: "MIN_GROUP_SIZE",
        },
    },
]

export const typeComponents = [
    {
        type: "text",
        component: "FormText",
    },
    {
        type: "textarea",
        component: "FormTextarea",
    },
    {
        type: "select",
        component: "FormSelect",
    },
    {
        type: "geo",
        component: "FormGeo",
    },
    {
        type: "city",
        component: "FormCity",
    },
    {
        type: "communication",
        component: "FormCommunication",
    },
    {
        type: "medias",
        component: "FormMedia",
    },
    {
        type: "opening_periods",
        component: "FormOpeningPeriod",
    },
    {
        type: "price_periods",
        component: "FormPricePeriod",
    },
    {
        type: "radio",
        component: "FormRadio",
    },
    {
        type: "date",
        component: "FormDate",
    },
    {
        type: "numeric",
        component: "FormNumeric",
    },
    {
        type: "contact_city",
        component: "FormContactCity",
    },
]

export const aspectFields = [
    "DESC_COURT_FR",
    "DESC_LONG_EN",
    "IMAGE",
    "EMAIL",
    "FACEBOOK",
    "FAX",
    "GOOGLE",
    "WEBSITE",
    "PHONE",
    "TRIPADVISOR",
    "YELP",
    "OPENING_HOURS",
    "COMPLEMENT_TARRIFAIRE",
    "DESC_COURT_EN",
    "DESC_LONG_FR",
    "DESC_COURT_DE",
    "DESC_COURT_IT",
    "DESC_COURT_ES",
    "DESC_COURT_NL",
    "DESC_COURT_RU",
    "DESC_COURT_ZH",
    "DESC_COURT_PT",
    "DESC_COURT_JA",
    "DESC_LONG_DE",
    "DESC_LONG_IT",
    "DESC_LONG_ES",
    "DESC_LONG_NL",
    "DESC_LONG_RU",
    "DESC_LONG_ZH",
    "DESC_LONG_PT",
    "DESC_LONG_JA",
    "YOUTUBE",
    "INSTAGRAM",
    "DESC_PORTRAIT",
    "BOOKING_LINK",
    "BOOKING_LINK_EN",
    "COMPLEMENT_LOCALISATION",
    "DESC_HAND_AUDITIF",
    "DESC_HAND_MOTEUR",
    "DESC_HAND_VISUEL",
    "DESC_HAND_MENTAL",
    "NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE",
    "DESC_PARTY_MENU",
    "TWITTER",
    "DESC_2024_INNOVATION",
    "OFFER_PROMOTIONS",
    "COMPLEMENT_ACCUEIL",
    "LINKEDIN",
    "TIKTOK",
    "DESC_2025_INNOVATION",
    "DESC_2026_INNOVATION",
    "DESC_2027_INNOVATION",
    "DESC_ALERTE",
    "DESC_ADVICE_SUGG",
    "DESC_CHILD_SERVICE",
    "DESC_CYCLIST_SERVICE",
    "DESC_RIDERS_SERVICE",
    "DESC_HIKERS_SERVICE",
    "DESC_TAKEAWAY",
    "DESC_WINES_LABEL",
    "DESC_CRUISERS_SERV",
    "DESC_GIFT_CERTIFICATE",
    "OfferType",
    "MAX_GROUP_SIZE",
    "DESC_TOURISME_DURABLE",
]

export const thematisedDescCodeConnection = [
    {
        code: "DESC_2025_INNOVATION",
        name: "description_2025_innovation",
        label: "Nouveauté 2025",
    },
    {
        code: "DESC_ALERTE",
        name: "alerte",
        label: "Alerte visiteurs",
    },
    {
        code: "DESC_ADVICE_SUGG",
        name: "advices_suggestions",
        label: "Conseils et suggestions",
    },
    {
        code: "DESC_CHILD_SERVICE",
        name: "child_service",
        label: "Services pour les enfants",
    },
    {
        code: "DESC_CYCLIST_SERVICE",
        name: "cyclist_service",
        label: "Services pour les cyclistes",
    },
    {
        code: "DESC_RIDERS_SERVICE",
        name: "riders_service",
        label: "Services pour les cavaliers",
    },
    {
        code: "DESC_HIKERS_SERVICE",
        name: "hikers_service",
        label: "Servies pour les randonneurs",
    },
    {
        code: "DESC_TAKEAWAY",
        name: "takeaway",
        label: "Vente à emporter",
    },
    {
        code: "DESC_WINES_LABEL",
        name: "wines_label",
        label: "Label \"Vignobles et Découvertes\"",
    },
    {
        code: "DESC_CRUISERS_SERV",
        name: "cruisers_service",
        label: "Services pour les croisiéristes",
    },
    {
        code: "DESC_GIFT_CERTIFICATE",
        name: "gift_certificate",
        label: "Bon cadeau",
    },
    {
        code: "DESC_2024_INNOVATION",
        name: "description_2024_innovation",
        label: "Nouveauté 2024",
    },
    {
        code: "DESC_PORTRAIT",
        name: "description_portrait",
        label: "Portrait",
    },
    {
        code: "OFFER_PROMOTIONS",
        name: "offer_promotions",
        label: "Offres promotionnelles",
    },
    {
        code: "DESC_TOURISME_DURABLE",
        name: "description_sustainable_tourism",
        label: "Tourisme durable",
    },
    {
        code: "DESC_2026_INNOVATION",
        name: "description_2026_innovation",
        label: "Nouveauté 2026",
    },
    {
        code: "DESC_2027_INNOVATION",
        name: "description_2027_innovation",
        label: "Nouveauté 2027",
    },
    {
        code: "DESC_UNAVOIDABLE",
        name: "description_unavoidable",
        label: "Coups de cœur / Incontournables",
    },
]

export const aspectElements = [
    {
        name: 'business',
        icon: '💼',
        label: "Tourisme d'affaires",
    },
    {
        name: 'summer',
        icon: '🔆',
        label: 'Été'
    },
    {
        name: 'winter',
        icon:  '❄️',
        label: 'Hiver',
    },
]